<div class="avenue-eval-wrapper">
  <div class="video-wrapper">
    <div class="left" fxLayout="column" fxLayoutAlign="center center">
      <h4>{{ videoTitle }}</h4>
      @if (!assignment?.studentVideoUrl) {
        <no-video-found
        ></no-video-found>
      }
      @if (assignment?.studentVideoUrl) {
        <video
          class="media-player"
          #studentVideo
          playsinline
          controls
          [src]="assignment?.studentVideoUrl"
        ></video>
      }
      <button mat-button color="primary" (click)="previewActivity()">
        Preview Activity
      </button>
      @if (!isStudent) {
        <div class="student-comment-container">
          <h4>Student Comments</h4>
          <div class="student-comments">
            @if (assignment?.studentComments) {
              <div>
                {{ assignment?.studentComments }}
              </div>
            }
            @if (!assignment?.studentComments) {
              <div>
                <i>No Comments Provided</i>
              </div>
            }
          </div>
          <div
            fxLayout="row"
            fxLayoutAlign="start"
            class="student-self-eval"
            >
            <div>
              Student Self Evaluation:
              {{ assignment?.studentScore }}/10
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  <!-- Possible discussion html -->
  <!-- <div class="discussion-container">
  <h4 class="discussion-title">Discussion</h4>
  <div class="discussion-content">
    <div *ngFor="let discussion of discussions" class="discussion">
      <div class="author">{{ discussion.author }}</div>
      <div class="comment">{{ discussion.comment }}</div>
    </div>
  </div>
</div> -->
</div>
